<template lang='pug'>
  .billboards-carousel(v-if='billboards.length > 0' data-per-page='1' data-loop='true')
    slider(
      carouselType='billboard'
      containerClass='billboard-slider'
      :autoplay='true'
      :items='1'
      :slideBy='1'
      :speed='1000'
      :nav='true'
      :showArrows='showArrows'
      :mouseDrag='mouseDrag'
      @cloneCountChanged='cloneItems',
      ref='billboardSlider'
    )
      .wrapper(slot='slider-content' :class='navDotsSizeClass')
        .billboard-slider(:class='{ "with-tnc": hasTerms }')
          .carousel-item.tns-item(
            v-for='(billboard, index) in loopedBillboards'
            :key='`billboards-carousel-${billboard.id}-${index}`'
          )
            template(v-if='billboard.attributes.link')
              a(
                :href='billboard.attributes.link'
                :target='billboard.attributes["new-tab"] ? "_blank" : null'
                :rel='billboard.attributes["new-tab"] ? "noopener" : null'
                @click='gaTrack($event, billboard.attributes["image-url"])'
              )
                img.banner-image(
                  v-if='index === 0'
                  :src='billboard.attributes["image-url"]'
                  :alt='billboard.attributes["alt-text"]'
                  :data-billboard-id='billboard.id'
                )
                img.banner-image(
                  v-else
                  v-lazy='billboard.attributes["image-url"]'
                  :alt='billboard.attributes["alt-text"]'
                  :data-billboard-id='billboard.id'
                )

            template(v-else)
              img.banner-image(
                v-if='index === 0'
                :src='billboard.attributes["image-url"]'
                :alt='billboard.id'
                :data-billboard-id='billboard.id'
              )
              img.banner-image(
                v-else
                v-lazy='billboard.attributes["image-url"]'
                :alt='billboard.id'
                :data-billboard-id='billboard.id'
              )

            a.terms-link(href='#billboard-terms' data-toggle='modal' v-t='"common.termsAndConditions"' v-if='billboard.attributes["terms-and-conditions"]' @click='showTermsModal($event, billboard)')

    terms-and-conditions(
      v-if='currentBillboard.attributes && currentBillboard.attributes["terms-and-conditions"]'
      :image='currentBillboard.attributes["terms-and-conditions"]["image-url"]'
      :description='currentBillboard.attributes["terms-and-conditions"].description'
      :title='currentBillboard.attributes["terms-and-conditions"].title'
    )
</template>

<script>
import Slider from '@/components/shared/slider.vue'
import TermsAndConditions from './terms-and-conditions.vue'
import { adjustLoopedItems } from '@/modules/services/tiny-slider'

export default {

  components: {
    TermsAndConditions,
    Slider
  },
  props: {
    billboards: {
      type: Array,
      default: () => []
    },
    showArrows: {
      type: Boolean,
      default: false
    },
    navDotsSizeClass: {
      type: String,
      default: 'default-nav'
    },
    mouseDrag: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      currentBillboard: {},
      frontBillboards: [],
      rearBillboards: []
    }
  },

  computed: {
    isMobile: () => vueSupport.isMobile,
    i18nSiteCountryLs: () => I18n.siteCountryLs,
    hasTerms () {
      return this.billboards.find(b => b.attributes['terms-and-conditions'])
    },
    loopedBillboards () {
      return this.frontBillboards.concat(this.billboards).concat(this.rearBillboards)
    }
  },

  methods: {
    gaTrack (event, imageUrl) {
      if (window.ga) {
        window.ga('send', 'event', 'Billboard', 'Click', `${this.i18nSiteCountryLs}-${imageUrl}`, 1, { 'nonInteraction': 1 })
      }
    },

    showTermsModal (event, billboard) {
      this.currentBillboard = billboard
    },

    cloneItems () {
      [this.frontBillboards, this.rearBillboards] = adjustLoopedItems(this.$refs.billboardSlider.slider, this.billboards)
    }
  }
}
</script>

<style lang='scss'>
  .billboards-carousel {
    width: 100%;

    .slider-container {
      .arrow {
        background: rgba(255, 255, 255, 0.5);
        opacity: 0;
        -webkit-transition: all .5s ease-in-out;
        -moz-transition: all .5s ease-in-out;
        -ms-transition: all .5s ease-in-out;
        -o-transition: all .5s ease-in-out;
        transition: all .5s ease-in-out;
        z-index: 600;
      }

      &:hover {
        .arrow {
          opacity: 1;
        }
      }

      .carousel-item.tns-item {
        padding: 0px;
      }

      .wrapper {
        width: 100%;
        overflow: hidden;
        margin: auto;

        .tns-nav {
          height: 20px;
          width: 100%;
          position: relative;
          text-align: center;
          clear: both;
          margin-top: 10px;

          button[type=button] {
            display: inline-block;
            vertical-align: middle;
            cursor: default;
            outline: none;
          }
        }

        &.default-nav {
          .tns-nav {
            button[type=button] {
              height: 10px;
              width: 10px;
            }
          }
        }

        &.sm-nav {
          .tns-nav {
            button[type=button] {
              height: 10px;
              width: 10px;
            }
          }
        }
      }
    }
  }
</style>

<style scoped lang='scss'>
  .banner-image {
    width: 100%;
    vertical-align: top;

    @include media-breakpoint-up(sm) {
      max-height: 500px;
    }
  }

  .terms-link {
    height: 25px;
    width: 120px;
    border: 0;
    transition: all 0.3s ease 0s;
    cursor: pointer;
    text-decoration: underline;
    text-transform: none;
    font-size: 11px;
    line-height: 25px;
    text-align: center;
    display: block;

    &:hover {
      background: $grey-dark;
      color: $white;
    }
  }
</style>
